export { isAutomationPresentation } from './isAutomationPresentation'
